import { tryCatchHelper } from '../../../helpers';
import { ACTIVO_MODULOS } from './SystemReducer';
import { oneSystemService, saveSystemService } from './SystemService';

export const saveSystemAction = async ({ dispatch, notify }, id, data) => {
  try {
    const res = await saveSystemService(id, data);
    notify(res.data.message);
    await oneSystemAction(dispatch);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const oneSystemAction = async (dispatch) => {
  try {
    const res = await oneSystemService();
    dispatch({ type: ACTIVO_MODULOS, payload: res.data.data });
    return res.data.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
